export default __webpack_public_path__ + "static/media/V660_B_BD.632cf4ce.pdf";